module.exports = __webpack_public_path__ + "static/img/2345_img_4.36741887.png";